<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-running`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.5 4a6.5 6.5 0 110 13 6.5 6.5 0 010-13zm-6.273 14.5l.021-.023.268.224c.39.273.78.569 1.17.887 3.518 2.433 6.444 2.223 9.29-.628.122-.123.275-.287.46-.494a1 1 0 011.274-.185l.1.07 1.563 1.259.012.01a1 1 0 01.111 1.43c-.07.079-.131.148-.186.207-4.274 4.631-9.316 5.25-14.535 1.857l-1.458 3c7.29 1.89 10.629 6.72 9.453 13.997-.104.623-.206 1.18-.309 1.671a17.05 17.05 0 01-.082.373 1 1 0 01-1.255.733l-1.924-.563a1 1 0 01-.695-1.18c.03-.13.055-.251.078-.365.078-.386.158-.826.24-1.317.867-5.367-1.354-8.407-7.296-9.664L23.8 33.356l-.063.119c-3.508 6.13-8.416 7.898-13.92 4.981a12.472 12.472 0 01-.495-.281 1 1 0 01-.345-1.284l.058-.101 1.103-1.677a1 1 0 011.334-.318c.252.145.458.256.617.333 3.236 1.556 5.686.536 7.987-3.316l.156-.266 5.18-10.659c-2.903-1.383-5.42-.772-7.888 1.83-.065.068-.141.15-.228.249a1 1 0 01-1.276.185l-.1-.07-1.558-1.254-.034-.029a1 1 0 01-.09-1.41c.124-.141.23-.259.32-.354 4.32-4.578 9.41-5.088 14.67-1.533zM13 14a1 1 0 00-1-1H4a1 1 0 00-1 1v2a1 1 0 001 1h8a1 1 0 001-1v-2zm22.5-6a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM25 8a1 1 0 00-1-1H8a1 1 0 00-1 1v2a1 1 0 001 1h16a1 1 0 001-1V8z"/></svg>
</template>
<script>

export default {
  name: 'IconRunning',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
